<script>
  import Sparkline from "./Sparkline.svelte";
  export let rankingData;
  export let maxFrequency;
  export let lineColor;
  export let labels;
  import { slide } from "svelte/transition";

  let innerWidth;
</script>

<svelte:window bind:innerWidth />

{#each rankingData as name, index}
  {#key name}
    <div class="name-row" transition:slide={{ delay: 0, duration: 700 }}>
      <div class="ranknumber">{name.rank}.</div>
      <div class="name">{name.name}</div>
      <div class="sparkline">
        <Sparkline
          width={innerWidth < 500 ? 160 : 200}
          height={80}
          sparkLineData={name.data}
          sparkLineDataLabel={name.number}
          {maxFrequency}
          {lineColor}
          {index}
          {labels}
        />
      </div>
    </div>
  {/key}
{/each}

<style>
  .name-row {
    width: 100%;
    display: flex;
    align-items: flex-end;
    line-height: 1;
  }
  .ranknumber {
    font-size: 2.5rem;
    font-weight: 100;
    width: 64px;
    text-align: right;
    margin-right: 10px;
  }
  .name {
    font-size: 2.5rem;
    font-weight: 100;
    width: 170px;
  }
  @media only screen and (max-width: 500px) {
    .ranknumber {
      text-align: left;
      width: 28px;
    }
    .name {
      width: 100px;
    }
  }
</style>
